import { useParams } from "react-router-dom";
import { PageHeader, BreadcrumbItem } from "@/components/feature/PageHeader";
import { CreateGroupWizard } from "../components/CreateGroupWizard";

export default function EditGroupPage() {
  const { id } = useParams<{ id: string }>();
  return (
    <div>
      <PageHeader
        breadcrumb={
          <>
            <BreadcrumbItem label="Home" to="/" />
            <BreadcrumbItem label="Groups" to="/groups" />
            <BreadcrumbItem label="Edit group" isLast />
          </>
        }
        title="Edit group"
        subtitle="Only draft groups can be edited. These settings lock permanently once the group is active."
      />
      <CreateGroupWizard groupId={id} />
    </div>
  );
}